import axios from 'axios'
import qs from 'qs'
import store from '@/state/store'

const api = axios.create()
api.defaults.baseURL = `${process.env.VUE_APP_API_URL}/`
api.defaults.timeout = 30000
api.defaults.paramsSerializer = params => {
  return qs.stringify(params, {indices: false})
}

const requestSuccessHandler = config => {
  if (store.getters['auth/isAuthenticated']) {
    if (config.tablet) {
      config.headers.common['Authorization'] = `Bearer ${config.tablet}`
    } else {
      config.headers.common['Authorization'] = `Bearer ${store.getters['auth/getAccessToken']}`
    }
    if (config.hasOwnProperty('cancelToken')) {
      store.dispatch('app/startApiCall')
    }
  }
  config.url =
    config.url.charAt(config.url.length - 1) === '/' || config.url.includes('?')
      ? `${config.url}`
      : `${config.url}/`
  return config
}

const requestErrorHandler = error => {
  if (!!process.env.VUE_APP_DEBUG) {
    console.warn('API Error request status', error)
  }
  return Promise.reject(error)
}

const responseSuccessHandler = response => {
  if (typeof response.data === 'string' && response.data !== null) {
    //console.log(response)
    //return { response: response.data }
  }
  if (response.config.hasOwnProperty('cancelToken')) {
    store.dispatch('app/finishApiCall')
  }
  const content = response.headers['content-disposition']
  if (content) {
    const regex = /^.*filename[^;=\n]*=(([\'"]).*?\2|[^;\n]*)[\n;]?$/
    const filename = content.match(regex)
    return {blob: response.data, filename: filename[1]}
  }

  return response.data
}

let subscribers = []
const subscribeTokenRefresh = cb => subscribers.push(cb)
const onTokenRefreshed = err => subscribers.map(cb => cb(err))

const responseErrorHandler = error => {
  if (!!process.env.VUE_APP_DEBUG) {
    console.warn(`API ERROR: `, error)
  }

  if (error.response) {
    if (error.config.method === 'get') {
      //store.dispatch('app/apiHasErrored')
    }
    if (error.response.status === 500) {
      store.dispatch('app/notification', {type: 'error', group: 'app', text: `server_error`})
      store.dispatch('app/finishApiCall')
      return Promise.reject()
    }
    if (error.response.status === 405) {
      store.dispatch('app/notification', {type: 'error', group: 'app', text: `not_permitted`})
      store.dispatch('app/finishApiCall')
      return Promise.reject()
    }
    if (error.response.status === 404) {
      store.dispatch('app/notification', {type: 'error', group: 'app', text: `not_found`})
      store.dispatch('app/finishApiCall')
      return Promise.reject()
    }
    if (error.response.status !== 401) {
      store.dispatch('app/finishApiCall')
      if (
        typeof error.response.data === 'object' &&
        error.response.data !== null &&
        error.response.data.detail
      ) {
        return Promise.reject({detail: error.response.data.detail})
      }
      return Promise.reject({detail: error.message})
    }
    if (
      error.response.data.description === 'Token is invalid or expired' ||
      error.response.data.code === 'user_not_found' ||
      error.response.data.code === 'user_inactive'
    ) {
      return Promise.resolve(store.dispatch('auth/tokenExpired'))
    }

    if (!store.getters['auth/isRefreshing']) {
      store.dispatch('auth/startRefreshing')
      store
        .dispatch('auth/refreshToken')
        .then(() => {
          onTokenRefreshed(null)
        })
        .catch(err => {
          onTokenRefreshed(err)
          return Promise.resolve(store.dispatch('auth/tokenExpired'))
        })
        .finally(() => {
          subscribers = []
          store.dispatch('auth/finishRefreshing')
        })
    }

    const initTokenSubscriber = new Promise((resolve, reject) => {
      subscribeTokenRefresh(errRefreshing => {
        if (errRefreshing) return reject(errRefreshing)

        error.response.config.headers.Authorization = `Bearer ${store.getters['auth/getAccessToken']}`
        return resolve(api.request(error.response.config))
      })
    })

    return initTokenSubscriber
  }

  return Promise.reject({error: error.message})
}

api.interceptors.request.use(requestSuccessHandler, requestErrorHandler)

api.interceptors.response.use(responseSuccessHandler, responseErrorHandler)

const addToQueue = promiseFactory => Promise.resolve().then(promiseFactory)

api.fetch = resource => addToQueue(() => api.get(`${resource}`))

const cancellableRequest = () => {
  let call
  return (resource, params = {}) => {
    if (call) {
      call.cancel('cancelled')
    }
    call = axios.CancelToken.source()
    return api.get(`${resource}`, {
      cancelToken: call.token,
      params: {...store.state.route.query, ...params},
    })
  }
}

api.query = cancellableRequest()

export const setApiLanguage = lang => (api.defaults.headers.common['Accept-Language'] = `${lang}`)

export default api
